module.exports = __webpack_public_path__ + "img/patent_7.dc033a9.jpg";